import React, { useContext, useState } from "react";
import { Col, Container, Row, Card, CardHeader } from "reactstrap";
import "leaflet/dist/leaflet.css";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import Avatar from "react-avatar";
import avatar1 from "../../../assets/images/users/avatar-user.png";
import { Spin, message } from "antd";
import { getVehicleById } from "../services/vehiculeApi";
import BreadCrumb from "../../../Components/Common/BreadCrumb/BreadCrumb";
import HistoryContext from "../../../Components/Hooks/HistoryContext";
import '../utils/style.css';
import VehicleResume from './vehicleResume';
import InspectionUser from './inspectionUser';
import IncidentUser from './incidentUser';
import VehiclePosition from './vehiclePosition';
import OldDriver from './oldDriver';
import { Tag } from "antd";
import { getInspectionByVehicleId } from "../../Inspection/services/inspectionsApi";
import { getDriverById } from "../../Drivers/services/driverApi";

const DetailVehicule = () => {
  const history = useContext(HistoryContext);
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("Résumé");

  const { data: vehicle, isLoading, isError, error } = useQuery(
    ['vehicle', id],
    () => getVehicleById(id),
    {
      enabled: !!id,
    }
  );
  const userId = vehicle?.actualUserId
  const { data: user, isLoading : loadingUser, isError : isErrorUser, error : errorUser} = useQuery(
    ['user', userId],
    () => getDriverById(userId),
    {
      enabled: !!userId,
    }
  );

  const tabs = ["Résumé", "Inspections", "Incidents", "Anciens chauffeurs", "Localisation"];
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const fileName = vehicle?.fileName;
  const imageUrl = fileName ? `${process.env.REACT_APP_API_MEDIA_URL}/print/${fileName}` : avatar1;

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb page="Détail véhicule" history={history} />
          <Card>
            <div className="imgVehicle mt-2">
              <img className="small-avatarVehicle" src={imageUrl} alt="" />
              <br/>
              <div className="text-center">
                <span className="nameVehicle">{vehicle?.model || "-"}</span>
                <span className="mb-2">
                  <Tag color={vehicle?.statut === "En Service"|| "En service" ? "green" : 
                            vehicle?.statut === "Hors service"|| "Hors Service"  ? "red" : 
                            vehicle?.statut === "En réparation" ? "orange" : 
                            "gray"}>
                    {vehicle?.statut || "-"}
                  </Tag>
                </span>
                <br/>
                <p>{user?.name || "Pas de Chauffeur"}</p>
              </div>
            </div>
            <hr className="hr"/>
            <Row>
              <Col lg={12}>
                <div className="tab-container">
                  <button className="big-button">
                    <div className="tab-container-wrapper">
                      {tabs.map((tab) => (
                        <button
                          key={tab}
                          className={`tab-button ${activeTab === tab ? "active" : ""}`}
                          onClick={() => handleTabChange(tab)}
                        >
                          {tab}
                        </button>
                      ))}
                    </div>
                  </button>
                </div>
              </Col>
              <Col lg={12}>
                {activeTab === "Résumé" && <VehicleResume />}
                {activeTab === "Localisation" && user && <VehiclePosition vehicle={vehicle} />}
              </Col>
              <Col lg={2}></Col>
              <Col lg={8}>
                {activeTab === "Inspections" && user && <InspectionUser user={user} />}
              </Col>
              <Col lg={2}></Col>
              <Col lg={2}></Col>
              <Col lg={8}>
                {activeTab === "Incidents" && user && <IncidentUser user={user}/>}
              </Col>
              <Col lg={2}></Col>
              <Col lg={2}></Col>
              <Col lg={8}>
                {activeTab === "Anciens chauffeurs" && user && <OldDriver user={user} />}
              </Col>
              <Col lg={2}></Col>
            </Row>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DetailVehicule;
